// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DetectionZoneCardinalDirection } from "./Shared.DetectionZoneCardinalDirection.gen";
import { TurnType } from "./Shared.TurnType.gen";

export interface ILaneDirectionJson {
	lane: number;

	direction: DetectionZoneCardinalDirection;

	turnType: TurnType | undefined;

	$type?: string | undefined;
}
export class LaneDirectionJson {
	constructor(data?: ILaneDirectionJson) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	lane: number = 0;

	direction: DetectionZoneCardinalDirection = 0;

	turnType: TurnType | undefined;

	static $type: string = "CoreApi.Models.Reports.LaneDirectionJson, ";
	$type?: string | undefined = LaneDirectionJson.$type;
}

